export default "__VITE_ASSET__7Docs0cl__"